import * as React from 'react'

function SvgQuestionmark(props, svgRef) {
  return (
    <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M10.5 0C4.7 0 0 4.7 0 10.5S4.7 21 10.5 21 21 16.3 21 10.5 16.3 0 10.5 0zm0 16.406a1.296 1.296 0 01-1.313-1.312c0-.739.538-1.313 1.313-1.313.701 0 1.313.574 1.313 1.313 0 .738-.612 1.312-1.313 1.312zm2.834-5.824l-1.85 1.148v.082a.998.998 0 01-.984.985.998.998 0 01-.984-.985v-.656c0-.328.164-.656.492-.861L12.346 8.9a.88.88 0 00.45-.779c0-.492-.446-.902-.938-.902H9.762c-.53 0-.903.41-.903.902a.998.998 0 01-.984.984.998.998 0 01-.984-.984c0-1.6 1.271-2.871 2.834-2.871h2.096c1.673 0 2.945 1.271 2.945 2.871 0 .984-.534 1.928-1.432 2.461z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgQuestionmark)
export default ForwardRef
